<template>
  <router-view :key="$route.path"></router-view> 
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: './assets/fontawesome/webfonts';
  @import './assets/fontawesome/scss/fontawesome.scss';
  @import './assets/fontawesome/scss/solid.scss';
  @import './assets/fontawesome/scss/regular.scss';
  @import './assets/fontawesome/scss/light.scss';
</style>